import React, { useState } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';
import { formatNumber } from '../lib/utils';

export default function VoteRail({ score = 0, userVote = 0, onVote, vertical = true, size = 'md' }) {
  const [currentVote, setCurrentVote] = useState(userVote);
  const [displayScore, setDisplayScore] = useState(score);

  const handleVote = (direction) => {
    const newVote = currentVote === direction ? 0 : direction;
    const scoreDiff = newVote - currentVote;
    setCurrentVote(newVote);
    setDisplayScore(prev => prev + scoreDiff);
    if (onVote) onVote(newVote);
  };

  const iconSize = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  const btnSize = size === 'sm' ? 'w-7 h-7' : 'w-8 h-8';

  return (
    <div className={`flex ${vertical ? 'flex-col' : 'flex-row'} items-center gap-0.5`} data-testid="vote-rail">
      <button
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleVote(1); }}
        className={`vote-btn ${btnSize} rounded-lg flex items-center justify-center transition-colors duration-150 hover:bg-[hsl(var(--muted))] ${currentVote === 1 ? 'upvoted text-[hsl(var(--upvote))]' : 'text-muted-foreground'}`}
        data-testid="post-upvote-button"
        aria-label="Voter pour"
      >
        <ChevronUp className={iconSize} strokeWidth={currentVote === 1 ? 3 : 2} />
      </button>
      <span
        className={`tabular-nums font-semibold text-sm ${currentVote === 1 ? 'text-[hsl(var(--upvote))]' : currentVote === -1 ? 'text-[hsl(var(--downvote))]' : 'text-foreground'}`}
        data-testid="post-karma-count"
      >
        {formatNumber(displayScore)}
      </span>
      <button
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleVote(-1); }}
        className={`vote-btn ${btnSize} rounded-lg flex items-center justify-center transition-colors duration-150 hover:bg-[hsl(var(--muted))] ${currentVote === -1 ? 'downvoted text-[hsl(var(--downvote))]' : 'text-muted-foreground'}`}
        data-testid="post-downvote-button"
        aria-label="Voter contre"
      >
        <ChevronDown className={iconSize} strokeWidth={currentVote === -1 ? 3 : 2} />
      </button>
    </div>
  );
}
